<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row d-flex align-items-center">
                    <div class="col-12 col-sm-6 col-lg-4 mb-3 mb-lg-0 d-flex align-items-center">
                        <div>
                            <g-avatar :size="100" font-size="28" class="mr-4" :name="providerFullName" />
                        </div>
                        <div>
                            <h3 v-text="providerName" />
                            <h4 v-text="clienySurname" />
                        </div>
                    </div>

                    <div class="col-12 col-sm-6 col-lg-3 mb-3 mb-lg-0 d-flex align-items-center">
                        <div>
                            <h4>DATOS</h4>
                            <span class="info-data mb-1">
                                <fa-icon :icon="['fal', 'user']" class="mr-1" />
                                {{ providerFullName }}
                            </span>
                            <span class="info-data mb-1">
                                <fa-icon :icon="['fal', 'mobile']" class="mr-1" />
                                {{ providerPhone }}
                            </span>
                            <span class="info-data mb-1">
                                <fa-icon :icon="['fal', 'envelope']" class="mr-1" />
                                {{ providerEmail }}
                            </span>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6 col-lg-5 mb-3 mb-lg-0 d-flex align-items-center">
                        <!-- <g-map
                            :address="address"
                            :show-header="false"
                            height="150"
                            style="width: 100%; margin-bottom: 0px"
                        /> -->

                        <provider-sales :id="id" />
                    </div>
                </div>
            </div>
            <div class="row d-flex">
                <div class="col-12 tabsTrigger">
                    <a-tabs
                        default-active-key="0"
                        :active-key="String(selectedTab)"
                        tab-position="bottom"
                        @change="(key) => (selectedTab = parseInt(key, 10))"
                    >
                        <a-tab-pane key="0" tab="Vista General" />
                        <a-tab-pane key="1" tab="Anotaciones" />
                    </a-tabs>
                </div>
            </div>
        </div>
        <general-tab
            v-if="selectedTab == 0"
            :general-info="generalInfo"
            :datos-geograficos="datosGeograficos"
            :data-for-tables="dataForTables"
        >
            <template v-slot:sidebar="{}">
                <!-- Gastos -->
                <order-list
                    app="expenses"
                    :view="`expenses_${view}`"
                    title="Ultimos gastos"
                    :show-generate-document="false"
                    :filter="expensesFilter"
                    :more="moreFilter"
                />
            </template>
        </general-tab>
        <comentarios-list v-if="selectedTab == 1" :application="app" :entity="id" :comments="provider._Comments" />
        <custom-form :id="0" ref="form" :app="app" :view="view" :visible="formEnabled" @close="closeForm" />
    </div>
</template>

<script>
import GMap from '../../components/map'
import customForm from './form'
import GeneralTab from '../../components/generalTab'
import OrderList from '../../components/order-list'
import comentariosList from '../../components/g-comments'

export default {
    name: 'ClientInfo',
    components: {
        GMap,
        customForm,
        GeneralTab,
        OrderList,
        comentariosList,
    },
    data() {
        return {
            app: 'providers',
            tab: 1,
            loading: false,
            provider: null,
            formEnabled: false,
            fields: {
                payment_method: 0,
                show_prices: 0,
                surcharge: 0,
            },
            expensesHeaders: [
                // {
                // 	title: 'ID',
                // 	index: '_EntityId',
                // 	order: true,
                // 	search: true
                // },
                {
                    title: 'Fecha',
                    index: '_EntityCreateDate',
                    order: true,
                    slot: '_date',
                },
                {
                    title: 'Serie',
                    index: 'serie',
                    search: false,
                    order: true,
                },
                {
                    title: 'Importe',
                    index: 'total',
                    slot: 'total',
                    order: true,
                    search: false,
                },
                // {
                // 	title: 'Estado',
                // 	index: 'status',
                // 	slot: 'status',
                // 	order: true
                // },
                // {
                // 	title: 'Metodo de pago',
                // 	index: 'payment_method',
                // 	order: true,
                // 	slot: 'payment_method'
                // },
                // {
                // 	title: 'Factura',
                // 	slot: 'factura'
                // }
                {
                    title: 'Acciones',
                    slot: '_actions',
                },
            ],
            selectedTab: 0,
        }
    },
    computed: {
        id() {
            if (this.$route.name === 'providerInfo') return parseInt(this.$route.params.id, 10) || 0
            return 0
        },
        view() {
            return `_providerWorks_${this.id}`
        },
        emptyProvider() {
            return !this.provider || !Object.keys(this.provider).length
        },
        providerName() {
            if (this.emptyProvider) return ''
            return this.provider.name
        },
        clienySurname() {
            if (this.emptyProvider || !this.provider.surname) return ''
            return this.provider.surname
        },
        providerFullName() {
            if (this.emptyProvider) return ''
            return `${this.providerName} ${this.clienySurname}`
        },
        providerPhone() {
            if (this.emptyProvider || !this.provider.phone) return 'Sin definir'
            return this.provider.phone
        },
        address() {
            if (this.emptyProvider) return ''
            return `${this.provider.address} | ${this.provider.location} - ${this.provider.cp}`
        },
        providerRazonSocial() {
            if (this.emptyProvider || !this.provider.legal_name) return 'Sin definir'
            return this.provider.legal_name
        },
        providerCif() {
            if (this.emptyProvider || !this.provider.cif) return 'Sin definir'
            return this.provider.cif
        },
        providerCP() {
            if (this.emptyProvider || !this.provider.cp) return 'Sin definir'
            return this.provider.cp
        },
        providerLocation() {
            if (this.emptyProvider || !this.provider.location) return 'Sin definir'
            return this.provider.location
        },
        providerState() {
            if (this.emptyProvider || !this.provider.state) return 'Sin definir'
            return this.provider.state
        },
        providerCountry() {
            if (this.emptyProvider || !this.provider.country) return 'Sin definir'
            return this.provider.country
        },
        providerIBAN() {
            if (this.emptyProvider || !this.provider.iban) return 'Sin definir'
            return this.provider.iban
        },
        providerBicSwift() {
            if (this.emptyProvider || !this.provider.bic_swift) return 'Sin definir'
            return this.provider.bic_swift
        },
        providerEmail() {
            if (this.emptyProvider || !this.provider.email) return 'Sin definir'
            return this.provider.email
        },
        generalInfo() {
            return [
                [
                    { label: 'Nombre:', value: this.providerName, col: 'col-12 col-md-4' },
                    { label: 'Teléfono:', value: this.providerPhone, col: 'col-12 col-md-4' },
                    { label: 'Razón Social:', value: this.providerRazonSocial, col: 'col-12 col-md-4' },
                ],
                [
                    { label: 'CIF / NIF / NIE:', value: this.providerCif, col: 'col-12 col-md-4' },
                    { label: 'IBAN:', value: this.providerIBAN, col: 'col-12 col-md-4' },
                    { label: 'BIC / SWIFT:', value: this.providerBicSwift, col: 'col-12 col-md-4' },
                ],
                [{ label: 'Email:', value: this.providerEmail, col: 'col-12' }],
            ]
        },
        datosGeograficos() {
            return {
                direccion: this.address,
                cp: this.providerCP,
                localidad: this.providerLocation,
                provincia: this.providerState,
                pais: this.providerCountry,
            }
        },
        dataForTables() {
            return {
                type: 'provider',
                id: this.id,
            }
        },
        expensesFilter() {
            return [
                {
                    _ParentOperator: 'AND',
                    _Operator: 'AND',
                    Fields: {
                        provider: {
                            type: 3,
                            int: parseInt(this.id, 10),
                            opt: '=',
                        },
                    },
                },
            ]
        },
        moreFilter() {
            return {
                field: 'provider',
                value: this.id,
            }
        },
    },
    async created() {
        await this.getData()
        this.$hub.$on('newProvider', () => {
            this.formEnabled = true
        })
    },
    beforeDestroy() {
        this.$hub.$off('newClient')
    },
    methods: {
        async getData() {
            this.loading = true

            const result = await this.$gestios.items(this.app).get(this.id)
            if (result.ok) {
                this.provider = result.data
                window.provider = this.provider
            } else {
                this.$router.replace({ name: '_404' })
            }

            this.loading = false
        },
        openForm() {
            this.formEnabled = true
        },
        closeForm() {
            this.formEnabled = false
        },
        async save() {
            this.loading = true

            const data = await this.$gestios.items('providers').edit({
                id: this.id,
                params: this.fields,
            })

            if (data.ok) this.$gestios.$message.success('Cliente actualizado correctamente')

            this.loading = false
        },
        openExpensesForm(item) {
            this.$router.push({
                name: 'expensesEdit',
                params: { id: item._EntityId },
            })
        },
    },
}
</script>

<style lang="scss" module>
@import './providers.scss';
</style>
<style lang="scss">
.info-data {
    display: block;
    white-space: nowrap;

    svg {
        min-width: 16px;
    }
}
.active {
    color: red;
}
.pointer {
    cursor: pointer !important;
}
</style>
